module.exports = __webpack_public_path__ + "static/media/logo-sesi_senai.9a4a365c.png";